const ENDPOINTS = {
	config_ui: '/api/v1/config',
	auth: '/api/v1/login',
	backend: '/api/v1/backend/info',
	media: '/api/v1/media',
	accounts: '/api/v1/accounts'
}

export default ENDPOINTS;